// extracted by mini-css-extract-plugin
export var flexContainer = "Info-module--flexContainer--ImJVT";
export var icon = "Info-module--icon--3rrFR";
export var infoContainer = "Info-module--infoContainer--9Hn9D";
export var link = "Info-module--link--YF2Di";
export var mainContainer = "Info-module--mainContainer--rH4Xl";
export var mobile = "Info-module--mobile--YeQUo";
export var mobilecontainer = "Info-module--mobilecontainer--2Gthm";
export var textWrapper = "Info-module--textWrapper--8m7pq";
export var wrapper = "Info-module--wrapper--GU01o";